import React from 'react';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { streetsSelector } from '../../../../store/selectors';
import useRequestStreets from '../../../../../../queries/useRequestStreets';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';
import { renderOption } from './utils';

const SelectStreets = ({ className }) => {
  const dispatch = useDispatch();
  const selectedStreets = useSelector(streetsSelector);

  const { data: streets, isFetching } = useRequestStreets({
    staleTime: Infinity,
  });

  const handleChange = (value) => {
    dispatch(setFilterState({ filterName: filterNames.streets, value }));
  };

  return (
    <Select
      onChange={handleChange}
      className={className}
      loading={isFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear={true}
      placeholder="Улица"
      value={streets ? selectedStreets : []}
      optionFilterProp="searchtext"
      optionLabelProp="label"
    >
      {streets?.map((street) => (
        <Select.Option
          key={street.id}
          value={street.id}
          searchtext={street.name}
          label={street.name}
        >
          {renderOption(street)}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectStreets;
